
export const keys = {
    all: ["user"],
    settings: () => [
            ...keys.all,
            "settings", {
            }
        ],
    image: (userID: number) => [
        ...keys.all,
            "image", {
                userID
            }
    ]
};
